import React, { Component } from 'react';
import { FaTrash, FaEdit, FaTimes } from 'react-icons/fa';
import InternalHeader from '../InternalHeader';
import Sidebar from '../Sidebar';
import './MyProfile.css';

class MyProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showConfirmModal: false,
            showUpdateModal: false,
            profileImage: null,
            profileName: '',
            firstName: '',
            lastName: '',
            initials: '',
            email: '',
            contactNumber: '',
            newProfileImage: null,
            selectedFile: null,
            isSidebarVisible: true,
            emailError: '',
            isEditable: false,
            successModalVisible: false,
            successMessage: '',
            showChangePasswordModal: false,
            resetEmail: '',
            resetEmailError: '',
        };
    }

    toggleSidebar = () => {
        this.setState(prevState => ({
            isSidebarVisible: !prevState.isSidebarVisible,
        }));
    };

    componentDidMount() {
        this.fetchUserProfile();
    }

    fetchUserProfile = async () => {
        try {
            const response = await fetch('/api/profile', {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.ok) {
                const userData = await response.json();
                const profileName = `${userData.firstName} ${userData.lastName}`;
                this.setState({
                    firstName: userData.firstName,
                    lastName: userData.lastName,
                    profileName,
                    initials: userData.initials,
                    contactNumber: userData.contactNumber || '',
                    email: userData.email.trim().toLowerCase(),
                    profileImage: userData.profileImage || null,
                });
            } else {
                console.error('Failed to fetch profile data');
            }
        } catch (error) {
            console.error('Error fetching profile data:', error);
        }
    };

    handleProfileClick = () => {
        if (this.state.isEditable) {
            this.setState({ showModal: true });
        }
    };

    closeModal = () => {
        this.setState({
            showModal: false,
            showConfirmModal: false,
            showUpdateModal: false,
            showChangePasswordModal: false,
            successModalVisible: false,
            newProfileImage: null,
            selectedFile: null
        });
    
    };

    closeConfirmModal = () => {
        this.setState({ showConfirmModal: false });
    };

    closeUpdateModal = () => {
        this.setState({ showUpdateModal: false, newProfileImage: null, selectedFile: null });
    };

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({
                newProfileImage: URL.createObjectURL(file),
                selectedFile: file
            });
        }
    };

    handleRemoveClick = () => {
        this.setState({ showConfirmModal: true });
    };

    confirmRemoveImage = async () => {
        try {
            await fetch('/api/remove-profile-image', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: this.state.email }),
            });

            this.setState({ profileImage: null });
            this.closeModal();
        } catch (error) {
            console.error('Error removing profile image:', error);
        }
    };

    handleUpdateClick = () => {
        this.setState({ showUpdateModal: true });
    };

    confirmUpdateImage = async () => {
        const { selectedFile, email } = this.state;
        if (selectedFile) {
            const formData = new FormData();
            formData.append('profileImage', selectedFile);
            formData.append('email', email);

            try {
                const response = await fetch('/api/upload-profile-image', {
                    method: 'POST',
                    body: formData,
                });
                const data = await response.json();

                if (data.profileImage) {
                    this.setState({ profileImage: data.profileImage });
                }
                this.closeModal();
            } catch (error) {
                console.error('Error updating profile image:', error);
            }
        }
    };

    handleOverlayClick = (e) => {
        if (e.target.className === 'modal-overlay') {
            this.closeModal();
        }
    };

    handleSaveProfile = async () => {
        const { firstName, lastName, email, contactNumber } = this.state;
        const updatedProfile = {
            firstName,
            lastName,
            email,
            contactNumber
        };

        try {
            const response = await fetch('/api/profile', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updatedProfile),
                credentials: "include"
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Profile updated:', data);
                this.setState({
                    isEditable: false,
                    emailError: '',
                    successMessage: 'Profile updated successfully.', // Set success message
                    successModalVisible: true, // Show success modal
                });
            } else {
                const data = await response.json();
                if (data.error && data.error === 'Email is already in use') {
                    this.setState({ emailError: data.error });
                } else {
                    console.error('Failed to update profile');
                }
            }
        } catch (error) {
            console.error('Error saving profile:', error);
        }
    };

    closeSuccessModal = () => {
        this.setState({ successModalVisible: false });
    };

    closeChangePasswordModal = () => {
        this.setState({ showChangePasswordModal: false, resetEmail: '', resetEmailError: '' });
    };

    handleSendResetLink = async () => {
        const { resetEmail } = this.state;

        if (!resetEmail || !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(resetEmail)) {
            this.setState({ resetEmailError: 'Please enter a valid email address.' });
            return;
        }

        try {
            const response = await fetch('/api/send-reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: resetEmail }),
            });

            if (response.ok) {
                this.setState({
                    successMessage: 'A password reset link has been sent to your email.',
                    successModalVisible: true,
                    showChangePasswordModal: false,
                });
            } else {
                const data = await response.json();
                this.setState({ resetEmailError: data.error || 'Failed to send reset link.' });
            }
        } catch (error) {
            console.error('Error sending reset link:', error);
            this.setState({ resetEmailError: 'An error occurred. Please try again later.' });
        }
    };

    render() {
        const {
            profileImage,
            profileName,
            initials,
            showModal,
            showConfirmModal,
            showUpdateModal,
            isEditable,
            emailError,
            successModalVisible,
            successMessage,
            showChangePasswordModal,
            resetEmail,
            resetEmailError,
        } = this.state;

        return (
            <div className={`create-patient-container ${this.state.isSidebarVisible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
                <InternalHeader moduleName="My Profile" toggleSidebar={this.toggleSidebar} />
                <div className="create-profile-content">
                    <Sidebar isSidebarVisible={this.state.isSidebarVisible} />
                    <div className='create-patient'>
                        <div className="button-group">
                            <button
                                className="create-patient-button"
                                onClick={() => {
                                    if (isEditable) {
                                        this.handleSaveProfile();
                                    } else {
                                        this.setState({ isEditable: !isEditable });
                                    }
                                }}
                            >
                                {isEditable ? "Save" : "Edit"}
                            </button>
                        </div>
                        <div className="create-patient-form">
                            <h2>My Profile</h2>
                            <div
                                className="profile"
                                onClick={this.handleProfileClick}
                                style={{ cursor: isEditable ? 'pointer' : 'default' }}  // Change cursor based on editable state
                            >
                                {profileImage ? (
                                    <img src={profileImage} alt="Profile" className="profile-image" />
                                ) : (
                                    <div className="profile-initials">{initials}</div>
                                )}
                            </div>
                            <div className="input-group">
                                <label className="label">First Name</label>
                                <input
                                    type="text"
                                    value={this.state.firstName}
                                    name="firstName"
                                    className="input-field"
                                    onChange={(e) => this.setState({ firstName: e.target.value })}
                                    disabled={!isEditable}
                                />
                            </div>
                            <div className="input-group">
                                <label className="label">Last Name</label>
                                <input
                                    type="text"
                                    value={this.state.lastName}
                                    name="lastName"
                                    className="input-field"
                                    onChange={(e) => this.setState({ lastName: e.target.value })}
                                    disabled={!isEditable}
                                />
                            </div>
                            <div className="input-group">
                                <label className="label">Email</label>
                                <input
                                    type="email"
                                    value={this.state.email}
                                    name="email"
                                    className="input-field"
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                    disabled
                                />
                                {emailError && <p className="error-message">{emailError}</p>}
                            </div>
                            <div className="input-group">
                                <label className="label">Contact Number</label>
                                <input
                                    type="tel"
                                    value={this.state.contactNumber}
                                    name="contactNumber"
                                    className="input-field"
                                    onChange={(e) => this.setState({ contactNumber: e.target.value })}
                                    disabled={!isEditable}
                                />
                            </div>

                            <a href="/change-password">
                                <button
                                    className="create-button-table-1"
                                >
                                    Change Password
                                </button>
                            </a>
                            <a href="/change-email">
                                <button
                                    className="create-button-table"
                                >
                                    Change Email
                                </button>
                            </a>

                            {/* Change Password Modal */}
                            {showChangePasswordModal && (
                                <div className="modal-overlay" onClick={this.handleOverlayClick}>
                                    <div className="modal" onClick={(e) => e.stopPropagation()}>
                                        <h3>Change Password</h3>
                                        <div class="modal-divider" />
                                        <label className="label">Email</label>
                                        <input
                                            type="email"
                                            value={resetEmail}
                                            onChange={(e) => this.setState({ resetEmail: e.target.value, resetEmailError: '' })}
                                            className="modal-input-field"
                                        />
                                        {resetEmailError && <p className="error-message">{resetEmailError}</p>}
                                        <div class="modal-divider-bottom" />
                                        <div className="modal-button-group">
                                            <button onClick={this.handleSendResetLink} className="modal-action-button">Send </button>
                                            <button onClick={this.closeChangePasswordModal} className="modal-action-button">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {showModal && (
                                <div className="modal-overlay" onClick={this.handleOverlayClick}>
                                    <div className="modal" onClick={(e) => e.stopPropagation()}>
                                        <button className="close-icon" onClick={this.closeModal}>&times;</button>
                                        <h3>Update Profile Image</h3>
                                        <div class="modal-divider" />
                                        <div className="image-options">
                                            <button onClick={this.handleUpdateClick}>
                                                Upload New Image
                                            </button>
                                            <button onClick={this.handleRemoveClick}>
                                                Remove Image
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {showConfirmModal && (
                                <div className="modal-overlay" onClick={this.handleOverlayClick}>
                                    <div className="modal confirm-modal" onClick={(e) => e.stopPropagation()}>
                                        <h3>Remove profile picture</h3>
                                        <div class="modal-divider" />
                                        <p>Are you sure you want to remove your profile picture?</p>
                                        <div class="modal-divider-bottom" />
                                        <div className="modal-button-group">
                                            <button onClick={this.confirmRemoveImage} className="confirm-button">Yes</button>
                                            <button onClick={this.closeConfirmModal} className="cancel-button">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {showUpdateModal && (
                                <div className="modal-overlay" onClick={this.handleOverlayClick}>
                                    <div className="modal update-modal" onClick={(e) => e.stopPropagation()}>
                                        <button className="close-icon" onClick={this.closeUpdateModal}>&times;</button>
                                        <h3>Upload New Profile Image</h3>
                                        <div class="modal-divider" />
                                        <input type="file" accept="image/*" onChange={this.handleFileChange} />
                                        <button className="action-button" onClick={this.confirmUpdateImage}>
                                            Upload
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Success Modal */}
                            {successModalVisible && (
                                <div className="modal-overlay" onClick={this.handleOverlayClick}>
                                    <div className="modal success-modal" onClick={(e) => e.stopPropagation()}>
                                        <h3>Sucess!</h3>
                                        <div class="modal-divider" />
                                        <p>{successMessage}</p>
                                        <div class="modal-divider" />
                                        <button className="confirm-button" onClick={this.closeSuccessModal}>Close</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MyProfile;